import PropTypes from 'prop-types';

function IFPantryInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11302)">
                <path
                    d="M8.24591 13.907C7.65273 13.6864 7.02164 13.5858 6.38927 13.6111C5.75691 13.6364 5.13586 13.7871 4.56219 14.0543C3.73385 14.4844 2.48338 15.3685 2.73427 15.7548C2.98516 16.1411 4.2874 16.3243 3.85332 17.3199C3.41924 18.3155 3.85332 18.6978 4.54626 18.9129C4.83289 18.9917 5.07863 19.1769 5.23331 19.4308C5.38799 19.6847 5.43995 19.988 5.37858 20.2788C5.2153 20.7687 5.48611 22.0351 6.38613 22.0948C7.28615 22.1546 7.91936 23.186 7.9552 23.6878C7.99104 24.1896 8.13441 24.7511 8.80743 24.8467C9.48046 24.9422 12.0133 25.0139 12.0292 20.6293C12.0292 17.0451 15.2151 18.3474 16.0594 18.8053C16.9037 19.2633 19.8865 19.5142 20.7268 17.8376C21.567 16.161 19.5679 16.5752 19.4086 16.0177C19.2493 15.4601 20.2568 14.9583 19.9502 14.1897C19.6436 13.4211 18.7555 13.9428 18.5285 12.9671C18.3015 11.9915 19.2533 10.7848 18.2537 10.5777C17.2541 10.3706 16.8718 10.6773 16.5293 10.1795C16.1868 9.68166 16.37 8.89315 15.7328 8.41128C15.0956 7.92941 12.5031 9.12413 12.0849 11.2786C11.6668 13.4331 12.1646 14.4207 11.1451 14.8628C10.1256 15.3048 9.77914 14.4207 8.24591 13.907Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M8.59637 17.4035C8.59637 17.4035 8.86718 16.149 12.2403 16.5871C15.7886 17.045 15.9957 15.8384 15.9957 15.8384"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.7532 13.9066C14.7532 13.9066 13.5585 13.4725 12.1368 16.5629C10.6474 19.8205 9.51636 19.3506 9.51636 19.3506"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M27.3256 9.79682L16.9713 1.99928C16.6688 1.67777 16.2949 1.432 15.8798 1.28187C15.4647 1.13173 15.02 1.08145 14.5819 1.1351C12.9132 1.38599 11.8141 3.28161 12.1247 5.36839C12.1972 5.955 12.3938 6.51945 12.7014 7.02415C13.009 7.52886 13.4206 7.96224 13.9088 8.29546V8.29546L24.4702 16.2603C24.7665 16.5493 25.124 16.768 25.5162 16.9004C25.9084 17.0327 26.3253 17.0753 26.7362 17.0249C28.4048 16.774 29.5238 14.8784 29.1933 12.7916C29.1242 12.1849 28.9207 11.6013 28.5976 11.0833C28.2745 10.5652 27.84 10.1257 27.3256 9.79682V9.79682Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M15.7223 8.69569C17.3908 8.44692 18.491 6.55231 18.1796 4.46395C17.8682 2.37559 16.2632 0.884301 14.5947 1.13307C12.9262 1.38183 11.826 3.27645 12.1374 5.36481C12.4487 7.45317 14.0537 8.94445 15.7223 8.69569Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.2378 4.85498L29.2093 12.78"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.0147 6.53564L29.1854 14.3173"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.3975 7.69824L28.6598 15.6869"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.5493 8.66602L27.5566 16.5631"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M25.2827 18.7812C25.8681 19.1795 27.5447 21.1428 27.7199 23.1261C27.8952 25.1093 27.4292 27.9049 25.3862 28.789C23.3433 29.6731 20.4401 30.7006 17.3896 27.7377C16.6494 27.0611 15.9722 26.3187 15.3665 25.5195C15.7648 25.5195 19.3489 22.8274 19.3489 22.8274C19.3489 22.8274 21.0136 24.8186 22.1366 24.5279C23.2596 24.2371 22.5747 22.4769 21.5273 21.2503C22.3795 20.2786 25.2827 18.7812 25.2827 18.7812Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M24.0703 21.173C25.1503 20.5495 25.7539 19.5731 25.4185 18.9921C25.0831 18.4112 23.9356 18.4457 22.8557 19.0692C21.7757 19.6928 21.1721 20.6692 21.5075 21.2501C21.8429 21.8311 22.9903 21.7966 24.0703 21.173Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.9875 25.2345C19.1208 24.5801 19.7676 23.5788 19.4322 22.9978C19.0968 22.4169 17.9062 22.4763 16.7728 23.1307C15.6395 23.785 14.9927 24.7864 15.3281 25.3673C15.6635 25.9483 16.8541 25.8888 17.9875 25.2345Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11302">
                    <rect width="30" height="30" fill="white" transform="translate(0.976562 0.194336)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFPantryInactive;

IFPantryInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFPantryInactive.defaultProps = {
    className: null,
    width: 28,
};
